/**
 * Red maple leaf badge shown left of Contact on Canadian pages.
 * Hover / focus reveals "Proudly Canadian" (or French equivalent).
 */
export function ProudlyCanadianBadge({ label }: { label: string }) {
  return (
    <span className="group/maple relative inline-flex items-center">
      <span
        className="inline-flex h-8 w-8 items-center justify-center"
        title={label}
        aria-label={label}
      >
        <svg
          viewBox="0 0 512 512"
          className="h-5 w-5"
          aria-hidden="true"
          focusable="false"
        >
          {/* Font Awesome Free canadian-maple-leaf (CC BY 4.0) */}
          <path
            fill="#c8102e"
            d="M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
          />
        </svg>
      </span>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 top-full z-50 mt-1 -translate-x-1/2 whitespace-nowrap rounded-md bg-slate-900 px-2 py-1 text-[11px] font-medium text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover/maple:opacity-100 group-focus-within/maple:opacity-100 dark:bg-white dark:text-slate-900"
      >
        {label}
      </span>
    </span>
  );
}
